import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ec6b6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "SearchForm__label" }, "Введите номер рейса для получения списка ТТН", -1))
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "SearchForm",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_the_input, {
      value: _ctx.state.number,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.number) = $event)),
      "is-invalid": _ctx.state_form$.number.$error,
      "validation-errors": _ctx.state_form$.number.$errors,
      class: "mt-3",
      placeholder: "Номер рейса"
    }, null, 8, ["value", "is-invalid", "validation-errors"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        type: "submit",
        loading: _ctx.loading,
        class: "primary small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}